import { Line, LineFlag, LineTitle } from "@dashboard/library";
import { CountryCode } from "libphonenumber-js";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

import {
  getNumberRoute,
  redirectToDashboard,
} from "@/helpers/navigation/navigation.helpers";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";

export function SectionNumber() {
  const { t } = useTranslation();
  const { line } = useGetLine();

  if (!line) {
    return null;
  }

  const handleOnClick = () => {
    redirectToDashboard(getNumberRoute(line.ID));
  };

  return (
    <SectionLayout data-test="number-section">
      <SectionHeader>{t("call_context.number")}</SectionHeader>
      <Line
        onClick={handleOnClick}
        number={line.phoneNumber}
        countryCode={line.countryISOCode as CountryCode}
        name={line.name}
        hasTooltip={false}
      >
        <LineFlag />
        <LineTitle />
      </Line>
    </SectionLayout>
  );
}
